var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.469727 14.4043C0.162109 14.1055 0.170898 13.5957 0.469727 13.2969L6.09473 7.66309L0.469727 2.03809C0.170898 1.73926 0.170898 1.23828 0.469727 0.930664C0.768555 0.614258 1.28711 0.623047 1.58594 0.930664L7.21094 6.55566L12.8359 0.930664C13.1348 0.623047 13.6445 0.623047 13.9521 0.930664C14.2598 1.22949 14.251 1.73926 13.9521 2.03809L8.32715 7.66309L13.9521 13.2969C14.251 13.5957 14.251 14.0967 13.9521 14.4043C13.6533 14.7119 13.1348 14.7031 12.8359 14.4043L7.21094 8.7793L1.58594 14.4043C1.28711 14.7031 0.777344 14.7031 0.469727 14.4043Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bac85c6c52f105ad5c640fe0881b9d19.svg";
export { ForwardRef as ReactComponent };